module.exports = __webpack_public_path__ + "static/media/objects2_04.2f5cf2c4.svg";